// Import of the module

import { Link } from "@heroui/link";
import i18n from "@/i18n";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table

export type Workbook = {
  id: number;
  client: string;
  workspace_group?: string;
  name: string;
  menu: string;
  menu_quantilia: string;
  sort_order: number;
  uuid: string;
  group_user_name?: string;
};

// Definition of the columns

export const workbooks_columns: ColumnDef<Workbook>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "workspace_group",
    header: () =>
      i18n.t("workbooks.columns.workspace_group", {
        ns: "tables",
        defaultValue: "Workspace Group",
      }),
    cell: ({ row }) => row.getValue("workspace_group") ?? "",
  },
  {
    accessorKey: "client",
    header: "Client",
  },
  {
    accessorKey: "name",
    header: "Name",
  },
  {
    accessorKey: "menu",
    header: "Menu",
  },
  {
    accessorKey: "menu_quantilia",
    header: "Menu Quantilia",
  },
  {
    accessorKey: "sort_order",
    header: () => <div className="text-right">Display Order</div>,
    cell: ({ row }) => (
      <div className="text-right">{row.getValue("sort_order")}</div>
    ),
  },
  {
    accessorKey: "uuid",
    header: "UUID",
  },
  {
    accessorKey: "group_user_name",
    header: "User Group",
    cell: ({ row }) => row.getValue("group_user_name") ?? "",
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
